import { api } from './client'

/**
 * C-04 — ROI e margine del marketing (`MarketingEconomicsController`, `/api/reports/marketing-economics`), dietro il flag
 * `report.roi_marketing`. Solo per chi vede gli importi reali e tutte le pratiche (altrimenti 403/404).
 * `roi` e `revenuePerLead` sono null quando il divisore è zero: mai infinito.
 */
export interface MarketingEconomicsFilters {
  /** "YYYY-MM-DD", inclusivo (data creazione lead e data spesa). */
  from?: string
  to?: string
  source?: string
  campaignId?: string
  leadProviderId?: string
}

export interface MarketingEconomicsRow {
  key: string
  label: string
  spend: number
  leads: number
  practices: number
  activations: number
  expected: number
  accrued: number
  collected: number
  commissions: number
  margin: number
  roi: number | null
  revenuePerLead: number | null
  costPerLead: number | null
}

export interface MarketingEconomics {
  totals: MarketingEconomicsRow
  byCampaign: MarketingEconomicsRow[]
  byProvider: MarketingEconomicsRow[]
  bySource: MarketingEconomicsRow[]
  limitations: string[]
}

export type MarketingDimension = 'campaign' | 'provider' | 'source'

export interface MarketingPractice {
  contractId: number
  referenceCode: string
  leadId: number
  activated: boolean
  expected: number
  accrued: number
  collected: number
  commissions: number
  margin: number
}

function qs(filters: MarketingEconomicsFilters, extra: Record<string, string | undefined> = {}): string {
  const p = new URLSearchParams()
  for (const [k, v] of Object.entries({ ...filters, ...extra })) if (v !== undefined && v !== '') p.set(k, String(v))
  const s = p.toString()
  return s ? `?${s}` : ''
}

export const marketingEconomicsApi = {
  report: (f: MarketingEconomicsFilters = {}) => api<MarketingEconomics>(`/api/reports/marketing-economics${qs(f)}`),
  drilldown: (f: MarketingEconomicsFilters, dimension: MarketingDimension, key: string) =>
    api<{ dimension: string; key: string; total: number; items: MarketingPractice[] }>(
      `/api/reports/marketing-economics/drilldown${qs(f, { dimension, key })}`),
}
